import Vue from "vue";
import VueI18n from "vue-i18n";

import br from "../locales/pt-BR.json";
import en from "../locales/en-GB.json";

Vue.use(VueI18n);

// Idiomas do Connect (aluno e professor). A escolha fica no navegador; o
// seletor de bandeiras da barra lateral chama setLocale().
export const LOCALES = ["pt", "en"];
const STORAGE_KEY = "locale";

// Tag BCP 47 de cada idioma, para Intl/toLocale* e para o <html lang>.
const LANGUAGE_TAGS = { pt: "pt-BR", en: "en-GB" };

function storedLocale() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return LOCALES.includes(value) ? value : null;
  } catch {
    return null;
  }
}

const i18n = new VueI18n({
  locale: storedLocale() || "pt",
  fallbackLocale: "pt",
  silentFallbackWarn: true,
  messages: {
    pt: br,
    en: en,
  },
});

if (typeof document !== "undefined") {
  document.documentElement.setAttribute("lang", LANGUAGE_TAGS[i18n.locale]);
}

export function currentLocale() {
  return i18n.locale;
}

// "pt-BR" | "en-GB": usar no lugar do "pt-BR" fixo em Intl e toLocale*.
export function languageTag() {
  return LANGUAGE_TAGS[i18n.locale] || LANGUAGE_TAGS.pt;
}

// Valores em reais continuam em BRL; so a pontuacao segue o idioma.
export function formatBRL(value) {
  return new Intl.NumberFormat(languageTag(), {
    style: "currency",
    currency: "BRL",
  }).format(Number(value) || 0);
}

// "outubro de 2026" / "October 2026". A API manda o rotulo do mes pronto, em
// portugues; quem tem o mes e o ano refaz o texto no idioma atual.
export function formatMonthYear(month, year) {
  const date = new Date(Number(year), Number(month) - 1, 1);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat(languageTag(), {
    month: "long",
    year: "numeric",
  }).format(date);
}

// Mesmo que formatMonthYear, a partir da chave "yyyy-MM" usada nas telas.
export function formatMonthKey(key, fallback = "") {
  const [year, month] = String(key || "").split("-");
  if (!year || !month) return fallback;
  return formatMonthYear(month, year) || fallback;
}

export function setLocale(locale, vuetify) {
  if (!LOCALES.includes(locale)) return;
  i18n.locale = locale;
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // Sem storage (aba anonima): o idioma vale so ate recarregar.
  }
  document.documentElement.setAttribute("lang", LANGUAGE_TAGS[locale]);
  if (vuetify) vuetify.lang.current = locale;
}

export default i18n;
